import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";

export class DeleteAgencyUserUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    // Deletes the Firebase Auth user and its Firestore record — irreversible.
    async execute(agencyId: string, uid: string): Promise<void> {
        return this.agencyRepository.deleteAgencyUser(agencyId, uid)
    }
}
